import React, { PureComponent } from 'react';
import moment from 'moment';
import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../services/fetchTools';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import './calendar.css';
import {Link} from 'react-router-dom';

let weekdayshort = moment.weekdaysShort()
let daysInMonth = [];
let rows = [];
let cells = [];
class Calendar extends PureComponent {
	
    constructor(props){
    	super(props);
    	this.width = props.width || "100%";
    	this.style = props.style || {};
    	this.style.width = this.width;
    	this.state = {

	        dateContext: moment(),
	        today:moment(),
	        currentMonth:moment().format("MMMM"),
	        currentYear:moment().format("Y"),
	        showMonthPopup:false,
	        showYearPopup:false,
	        selectedDay: null,
	        showYearNav:false,
	        events:[],
            selected_day:'',
            day_dailog:false,
            selected_day_events:[],
    	}
    	this.getTournamentDetails = this.getTournamentDetails.bind(this);
        this.handleClose = this.handleClose.bind(this);
    	
    }
    componentDidMount(){
    	this.getTournamentDetails();
    }

    getTournamentDetails(dateContext){
        var month = moment(dateContext).format("M");
        var year = moment(dateContext).format("Y");
        const url = `${getLocationOrigin()}/eagleeye/get_all_tournaments_buddy/?month=${month}&year=${year}`;
        const options = {...defaultOptions};

        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {
               this.setState({events:data.tournaments});
               console.log("tournaments from backend :",data.tournaments)
               // alert("fix");
           }).catch(error => error);
  	}


    weekdays = moment.weekdays();
    weekdaysShort = moment.weekdaysShort();
    months = moment.months();

    year = () => {
    	return this.state.dateContext.format("Y");
    }
    month = () => {
    	return this.state.dateContext.format("MMMM");
    }
    daysInMonth = () => {
    	return this.state.dateContext.daysInMonth();
    }
    currentDate = () => {
        console.log("currentDate: ", this.state.dateContext.get("date"));
        return this.state.dateContext.get("date");
    }
    currentDay = () => {
        return this.state.today.format("D");
    }

    firstDayOfMonth = () => {
        let dateContext = this.state.dateContext;
        let firstDay = moment(dateContext).startOf('month').format('d'); // Day of week 0...1..5...6
        return firstDay;
    }
    
    nextMonth = () => {
    	let dateContext = Object.assign({},this.state.dateContext);
    	dateContext = moment(dateContext).add(1,'month');
    	this.setState({
    		dateContext:dateContext
    	});
    	this.props.onNextMonth && this.props.onNextMonth();
        this.getTournamentDetails(dateContext);
    }

    prevMonth = () => {
    	let dateContext = Object.assign({},this.state.dateContext);
    	dateContext = moment(dateContext).subtract(1,'month');
    	this.setState({
    		dateContext:dateContext
    	});
    	this.props.onPrevMonth && this.props.onPrevMonth();
        this.getTournamentDetails(dateContext);
    }
    

    
    MonthNav = () => {
    	return (
    		<span>
    			{this.month()
                }
    		</span>
    	);
    }

    setYear = (year) => {
    	if (year > 2000){
    	let dateContext = Object.assign({},this.state.dateContext);
    	dateContext = moment(dateContext).set("year",year);
    	this.setState({
    		dateContext : dateContext,
    		showYearNav : false
    	})
    	}
        this.getTournamentDetails(dateContext);
    }

    

    onYearChange = (e) => {
    	this.setYear(e.target.value);
    	this.props.onYearChange && this.props.onYearChange(e,e.target.value);
    }

    showYearEditor = () => {
    	this.setState({
    		showYearNav:!this.state.showYearNav
    	});
    }

    onKeyUpYear =(e) =>{
    	if (e.which === 13 || e.which === 27){
    		this.setYear(e.target.value);
    		this.setState({
    			showYearNav : false
    		})
    	}
    	
    }

    handleClose(){
        this.setState({day_dailog:false});
    }

    YearNav = () => {
    	return (
    		this.state.showYearNav ?
    		<input 
    			defaultValue = {this.year()}
    			className="editor-year"
    			ref={(yearInput) => { this.yearInput = yearInput}}
    			onKeyUp = {(e) => this.onKeyUpYear(e)}
    			onChange = {(e) => this.onYearChange(e)}
    			type="number"
    			placeholder="year" />
    		:
    		<span  onClick={(e) => { this.showYearEditor()}}  >
    			{this.year()}
    		
    		</span>
    	); 
    }

    onDayClick = (e,day) => {
    	let month = this.state.dateContext.format("M");
        let year = this.year();
        var events_list = [];
        for(var i = 0;i <this.state.events.length;i++){
            var event = this.state.events[i];
            if(event.start_day == day || event.end_day == day || event.start_day < day && event.end_day > day){
                events_list.push(event);
            }
        }
        this.setState({selected_day:day,day_dailog:true,selected_day_events:events_list});
    	this.props.onDayClick && this.props.onDayClick(e,day);

    }

    render() {
        const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleClose}
        />
        ];
    	
    	console.log(this.state)


        // Map the weekdays i.e Sun, Mon, Tue etc as <td>
        let weekdays = this.weekdaysShort.map((day) => {
            return (
                <div style={{'marginLeft':"0%",'width':"14%"}} key={day} className="week-day">{day}</div>
            )
        });

        let blanks = [];
        for (let i = 0; i < this.firstDayOfMonth(); i++) {
            blanks.push(<div style={{'textAlign':"center",'width':"14%"}} key={i * 80} className="emptySlot">
                {" "}
                </div>
            );
        }

        console.log("blanks: ", blanks);
        var day_background_color = [];

        for(let day = 1; day <= this.daysInMonth(); day++){
        	var background_color = [];
        	for (let i=0 ; i<this.state.events.length ; i++){
        		let event = this.state.events[i];
        		
        		if(event.start_day == day || event.end_day == day || event.start_day < day && event.end_day > day){
        			background_color.push([event.background_color,event.name]);
        		}
        	}
        	var daywithcolor = [day,background_color];
        	day_background_color.push(daywithcolor);
        }
        


        let daysInMonth = [];
        for (let d = 1; d <= this.daysInMonth(); d++) {
        	let day = day_background_color[d-1];
        	var background_color = null;
        	var background_name = null;
            var event_for_day = [];
            for(var i = 0;i<day[1].length;i++){
               
                background_color = day[1][0][0];
                background_name = day[1][0][1];
                event_for_day.push(<div  style={{'background': background_color ,'fontSize':'12px'}}> 
                    {background_name}col-md-12
                    </div>
                    )
            }
        	
            

        	
            daysInMonth.push(
                <div onClick={(e) => {this.onDayClick(e,d)}} style={(d == this.currentDay() && this.state.currentMonth == this.month() && this.state.currentYear == this.year() )?{'textAlign':"center",'width':"14%",'backgroundColor':"wheat",borderRadius: '50%'} :{'textAlign':"center",'width':"14%",'paddingBottom':'5px','background': background_color,borderRadius: '50%'}} key={d}  >
                    <span  >{d}</span>
                </div>
            );


        }

        console.log("days: ", daysInMonth);
        var totalSlots = []
        for(var i=0;i<blanks.length;i++){
        	totalSlots.push(blanks[i]);
        }
        for(var i=0;i<daysInMonth.length;i++){
        	totalSlots.push(daysInMonth[i]);
        }
        
        let rows = [];
        let cells = [];

        totalSlots.forEach((row, i) => {
            if ((i % 7) !== 0) {
                cells.push(row);
            } else {
                let insertRow = cells.slice();
                rows.push(insertRow);
                cells = [];
                cells.push(row);
            }
            if (i === totalSlots.length - 1) {
                let insertRow = cells.slice();
                rows.push(insertRow);
            }
        });

        let trElems = rows.map((d, i) => {
            return (
                <div style={{'display':"flex",'marginLeft':"0%"}} key={i*100}>
                    {d}
                </div>
            );
        })

        return (
            <div className="calendar-container" style={this.style}>
                {this.state.day_dailog && this.state.selected_day_events.length > 0 &&
                        <Dialog
                        actions={okaction}
                        modal={false}
                        open={this.state.day_dailog}
                        onClick={this.handleClose}
                        autoDetectWindowHeight={true}
                        autoScrollBodyContent={true}
                        scroll={scroll}
                        dividers={scroll === 'paper'}
                      >
                            <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'textAlign':"center",'backgroundColor':"#32B6A7",'fontSize':"22px"}}>
                                <div className="col-md-4">
                                 Name
                                </div>
                                <div className="col-md-2">
                                Date
                                </div >
                                <div className="col-md-4">
                                Venue
                                </div>
                                <div className="col-md-2">
                                GameType
                                </div>
                            </div>
                           { this.state.selected_day_events.map((event,index) =>
                            
                            <div className="col-md-12"  style={{'display':"flex",'flexDirection':"row",'textAlign':"center",'marginTop':"10px"}}>
                                <div className="col-md-4">
                                <Link to={`../../crud/viewTournament/${event.id}`}>
                                        <div className="col-md-12">
                                        {event.name}
                                        </div>
                                </Link>
                                </div>
                                <div className="col-md-2">
                                    <div>
                                    {event.start_date}
                                    </div>
                                    <div style={{'textAlign':"center"}}>
                                    To
                                    </div>
                                    <div>
                                    {event.end_date}
                                    </div>
                                </div >
                                <div className="col-md-4">
                                {event.venue}
                                </div>
                                <div className="col-md-2">
                                {event.game_type}
                                </div>
                            </div>
                            )}
                        </Dialog>
                        
                }
                <div style={{'display':"flex",'flexDirection':"column",'textAlign':"center"}}>
                    <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'textAlign':"center"}}>
                        
                        	<div  className="col-md-4" >
                        		<i className="prev fa fa-fw fa-chevron-left" style={{'width':"10px"}} onClick={(e) => {this.prevMonth()}}>
                        		</i>
                        	</div>
                        	<div className="col-md-4" >
                        		<this.MonthNav />
                        		{" "}
                        		<this.YearNav />
                        	</div>
                        	<div  className="col-md-4" >
                        		<i className="prev fa fa-fw fa-chevron-right" onClick={(e) => {this.nextMonth()}}>
                        		</i>
                        	</div>
                        
                    </div>
                    <div style={{'marginTop':"10px"}}>
                        <div style={{'display':"flex",'flexDirection':"row",'textAlign':"center"}}>
                            {weekdays}
                        </div>
                        {trElems}
                    </div>
                    
                    
                </div>

            </div>

        );
    }
} 
export default Calendar ;


// WEBPACK FOOTER //
// ./src/app/components/EventCalendar/Calendar.js